import {
  ControllerListSuccess,
  ControllerAllListSuccess,
  ControllerDetailsSuccess,
  ControllerFiltersSuccess,
} from '../../actionTypes/controllerActions';

const inititalState = {
  controlersList: [],
  controllerAllList: [],
  controllerDetails: {},
  controllerFilters: [],
};

export const controllerReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ControllerListSuccess:
      return {
        ...state,
        controlersList: payload,
      };
    case ControllerAllListSuccess:
      return {
        ...state,
        controllerAllList: payload,
      };
    case ControllerDetailsSuccess:
      return {
        ...state,
        controllerDetails: payload,
      };
    case ControllerFiltersSuccess:
      return {
        ...state,
        controllerFilters: payload,
      };
    default:
      return state;
  }
};
